import { useAppSelector } from '@shared/hooks/redux';
import { CharacteristicCategoryType } from '@shared/types/characteristics';

import { Caption } from '../Caption/Caption';
import { EmptyState } from '../EmptyState/EmptyState';
import cls from './Characteristics.module.scss';

type Props = {
  productCharacteristics: CharacteristicCategoryType | undefined;
};

export const Characteristics = ({ productCharacteristics }: Props) => {
  const dataProps = useAppSelector((state) => state.product.data.props);
  const groups = productCharacteristics?.groups;

  const renderProps = (key: string) => {
    return dataProps[key]?.values
      ?.map(({ value }) => (value === 'true' && 'Да') || (value === 'false' && 'Нет') || value)
      ?.join(',');
  };

  if (!groups) {
    return <EmptyState />;
  }

  return (
    <div className={cls.wrap}>
      <Caption>Характеристики</Caption>
      <div className={cls.characteristicsWrap}>
        {groups.map((el) => {
          const items = el.items.filter((el) => dataProps[el.id] && el.visible).toSorted((a, b) => a.sort - b.sort);

          if (items.length > 0) {
            return (
              <div key={el.id}>
                <div className={cls.groupTitle}>{el.label}</div>
                <ul className={cls.grid}>
                  {items.map((item) => {
                    const key = item.id;

                    return (
                      <li
                        key={key}
                        className={cls.item}
                      >
                        <div className={cls.label}>
                          {dataProps[key]?.name}
                          <span>{dataProps[key]?.unit ? `, ${dataProps[key]?.unit?.shortName}` : ''}</span>
                        </div>
                        <div className={cls.value}>{renderProps(key)}</div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          }
        })}
      </div>
    </div>
  );
};
